<template>
  <q-form
    ref="formDesob"
    autofocus
    style="width: 100% !important;"
  >
    <div class="group-input col-12 row q-mt-sm">
      <label for="type-os">Tipo de OS</label>
      <q-select
        id="type-os"
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        ref="typeOSRef"
        v-model="requestData.typeOS"
        color="red-9"
        fill-input
        :options="listTypeOS"
        option-value="value"
        option-label="text"
        bg-color="white"
        :rules="[(val) => val.length !== '' || 'Campo Obrigatório']"
        lazy-rules
        @update:model-value="(typeOs) => handleTypeOs(typeOs)"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm" v-if="requestData.typeOS['value'] == 6">
      <label for="type-os">Qual necessidade para reparo no Drop?</label>
      <q-select
        id="type-os"
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        ref="typeOSRef"
        v-model="requestData.reason"
        color="red-9"
        fill-input
        :options="maintenanceReasons"
        map-options
        emit-value
        option-value="value"
        option-label="text"
        bg-color="white"
        :rules="[(val) => val.length !== '' || 'Campo Obrigatório']"
        lazy-rules
        @update:model-value="(reason) => handleObservationByReason(reason)"
      />
    </div>
    <div
      v-if="requestData.typeOS['value'] == 1"
      class="group-input col-12 row q-mt-sm"
    >
      <label for="type-os">Refazer desde o DROP?</label>
      <q-select
        id="type-os"
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        ref="redoDropRef"
        v-model="requestData.redoFromDrop"
        color="red-9"
        map-options
        emit-value
        fill-input
        @update:model-value="verifyDrop(requestData.redoFromDrop)"
        :options="[
          { label: 'Sim', value: true },
          { label: 'Não', value: false },
        ]"
        bg-color="white"
        :rules="[(val) => val.length !== '' || 'Campo Obrigatório']"
        lazy-rules
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <SelectCheckbox
        title="Motivo"
        :selection="requestData.motivoValue"
        :showAlert="true"
        :options="motivoDisabledBytypeOs || isMaintenanceTypeOs ? motivoOptions.slice(1) : motivoOptions"
        @selectedOption="(value) => setMotivation(value)"
        
      />
      <SelectCheckbox
        title="Agendamento"
        :disabledOption="isMaintenanceTypeOs ? ({
           isDisabled: isMaintenanceTypeOs.value,
          label: 'Realizar agendamento',
        }) : ({
          isDisabled: schedulingOnlyOptionByTypeOs.value,
          label: 'Abertura imediata',
        })"
        @selectedOption="(value) => setSchedulingValue(value)"
        :selection="requestData.schedulingValue"
        :options="displayScheduleOptions"
      />
      <div
        class="group-input col-12 row q-mt-sm"
        v-if="requestData.schedulingValue !== 'Abertura imediata'"
      >
        <label for="type-os">Opção 1</label>
        <div class="group-input col-12 row q-mt-sm flex justify-around">
          <q-select
            id="type-os"
            class="col-5 q-mt-sm form-tabulacao"
            outlined
            dense
            ref="typeOSRef"
            v-model="requestData.datePrimary"
            color="red-9"
            use-input
            hide-selected
            fill-input
            input-debounce="0"
            :options="datesAvailableForSelection.date"
            bg-color="white"
            lazy-rules
          />

          <q-select
            id="type-os"
            class="col-5 q-mt-sm form-tabulacao"
            outlined
            dense
            ref="typeOSRef"
            v-model="requestData.horaPrimary"
            color="red-9"
            use-input
            hide-selected
            fill-input
            input-debounce="0"
            :options="hoursAvailableForSelection"
            option-value="value"
            option-label="text"
            bg-color="white"
            lazy-rules
          />
        </div>
      </div>

      <div
        class="group-input col-12 row q-mt-sm"
        v-if="requestData.schedulingValue != 'Abertura imediata'"
      >
        <label for="type-os">Opção 2</label>
        <div class="group-input col-12 row q-mt-sm flex justify-around">
          <q-select
            id="type-os"
            class="col-5 q-mt-sm form-tabulacao"
            outlined
            dense
            ref="typeOSRef"
            v-model="requestData.dateSecundary"
            color="red-9"
            use-input
            hide-selected
            fill-input
            input-debounce="0"
            :options="datesAvailableForSelection.date"
            option-value="value"
            option-label="text"
            bg-color="white"
            lazy-rules
          />

          <q-select
            id="type-os"
            class="col-5 q-mt-sm form-tabulacao"
            outlined
            dense
            ref="typeOSRef"
            v-model="requestData.horaSecundary"
            color="red-9"
            use-input
            hide-selected
            fill-input
            input-debounce="0"
            :options="hoursAvailableForSelection"
            option-value="value"
            option-label="text"
            bg-color="white"
            lazy-rules
          />
        </div>
      </div>
    </div>
    <div class="group-input col-12 row q-mt-md">
      <label for="observation">Observação</label>
      <div class="col-12 row flex justify-around">
        <q-input
          v-model="requestData.observation"
          class="col-12 q-mt-sm"
          bg-color="white"
          color="red-9"
          maxlength="300"
          outlined
          autogrow
        />
      </div>
    </div>
  </q-form>

  <q-footer>
    <q-toolbar style="background: #e5e5e5">
      <div class="col-12 flex row">
        <div class="col-6 btn justify-center flex items-center">
          <q-btn
            unelevated
            rounded
            text-color="grey-8"
            @click="$emit('clearSchemaRequest')"
            label="Cancelar"
          />
        </div>
        <div class="col-6 btn justify-center flex items-center">
          <q-btn
            unelevated
            rounded
            color="red-9"
            label="Salvar"
            @click="
              handleValidateOsRequest()
                ? $emit('saveSchemaRequest', returnSchemaRequest())
                : ''
            "
          />
        </div>
      </div>
    </q-toolbar>
  </q-footer>
</template>

<script setup>
  import SelectCheckbox from "@/components/SelectCheckbox";
import { generateTenDaysWithoutSundayAndHolidays } from "@/utils/DateSchedules";
import moment from "moment-timezone";
import { useQuasar } from "quasar";
import { computed, onBeforeMount, onMounted, reactive, ref, watch } from "vue";

  let props = defineProps({
    listWriteOffCode: Array,
    itemOsContract: Object,
    citySelected: Object,
  });
  let emits = defineEmits(["saveSchemaRequest", "clearSchemaRequest"]);
  moment.locale("pt-br");

  const $q = useQuasar();
  let listTypeOS = ref([
    {
      text: "REFAZER MANUTENÇÃO",
      value: 1,
    },
    {
      text: "REFAZER INSTALAÇÃO",
      value: 2,
    },
    {
      text: "DESOBSTRUÇÃO DE INSTALAÇÃO",
      value: 3,
    },
    // {
    //   text: "DESOBSTRUÇÃO DE INSTALAÇÃO DIGITAL",
    //   value: 4,
    // },
    {
      text: "REFAZER MANUTENÇÃO - PON",
      value: 5,
    },
    {
      text: "MANUTENÇÃO REPARO NO DROP",
      value: 6,
    },
  ]);

  const maintenanceReasons = [
    {
      text: "DROP Embarrigado",
      value: "DROP Embarrigado",
    },
    {
      text: "DROP Desposicionado",
      value: "DROP Desposicionado",
    },
    {
      text: "DROP Rompido ou Danificado",
      value: "DROP Rompido ou Danificado",
    },
  ]

  let requestData = reactive({
    object_id: "",
    typeOS: "",
    datePrimary: "",
    dateSecundary: "",
    horaPrimary: "",
    horaSecundary: "",
    motivoValue: "",
    schedulingValue: "",
    observation: "",
    statusOS: 1,
    writeOffCode: "",
    check: false,
    replicate: false,
    source: "",
    redoFromDrop: false,
    reason: "",
    dateStartedAttendance: moment().tz("America/Sao_Paulo").format("YYYY-MM-DD HH:mm:ss"),

  });
  let motivoOptions = [
    {
      label: "Cliente",
      value: "Cliente",
      MessageAlert: "O cliente será cobrado pelo atendimento",
    },
    {
      label: "Claro",
      value: "Claro",
      MessageAlert: "O cliente está isento de cobranças",
    },
  ];
  let schedulingOptions = [
    {
      label: "Realizar agendamento",
      value: "Realizar agendamento",
    },
    {
      label: "Abertura imediata",
      value: "Abertura imediata",
    },
  ];

  let contract = reactive({
    osRequests: [],
  });
  let confirmationReplicateWriteOffCode = ref(false);
  let modalReplicateWriteOffCode = ref(false);
  let formDesob = ref(null);

  let isSpecialTimesAvaliable = computed(() => {
    return requestData.typeOS.value !== 3;
  })

  let datesAvailableForSelection = reactive({
  date: [],
});

  let hoursAvailableForSelection = computed(() => { 
    return [
      {
        id: 1,
        text: isSpecialTimesAvaliable.value ? "08h - 11h" : "08h - 12h",
        value: isSpecialTimesAvaliable.value ? "08 - 11" : "08 - 12",
      },
      {
        id: 2,
        text: isSpecialTimesAvaliable.value ? "11h - 14h" : "12h - 15h",
        value: isSpecialTimesAvaliable.value ? "11 - 14 " : "12 - 15",
      },
      {
        id: 3,
        text: isSpecialTimesAvaliable.value ? "14h - 17h" : "15h - 18h",
        value: isSpecialTimesAvaliable.value ? "14 - 17" : "15 - 18",
      }
    ];
  });

  let schemaRequest = reactive({
    typeOS: "",
    datePrimary: "",
    dateSecundary: "",
    hourInitialPrimary: "",
    hourFinishPrimary: "",
    hourInitialSecundary: "",
    hourFinishSecundary: "",
    motivoValue: "",
    schedulingValue: "",
    observation: "",
    statusOS: 1,
    writeOffCode: "",
    check: false,
    replicate: false,
    source: "",
    redoFromDrop: false,
    
  });

  let schedulingOnlyOptionByTypeOs = computed(() => {
    return requestData.typeOS.value == 3 || requestData.typeOS.value !== 2 && requestData.typeOS.value !== 6;
  });


  let motivoDisabledBytypeOs = computed(() => {
    return requestData.typeOS.value == 3;
  });

  let isMaintenanceTypeOs = computed(() => {
    return requestData.typeOS.value === 6;
  });

  function filterdatesHoursAvailableForSelection(val, update) {
    update(() => {
      datesAvailableForSelection =
        datesAvailableForSelection.filter((date) => {
          return date != requestData.datePrimary;
        });
    });
  }

  function openConfirmationReplicateWriteOffCode() {
    if (requestData.writeOffCode == "") {
      confirmationReplicateWriteOffCode.value = false;
      $q.notify({
        message: "Selecione pelo menos um código baixa antes de replicar.",
        color: "red-9",
        position: "top",
      });
      return;
    }

    if (confirmationReplicateWriteOffCode.value == true) {
      modalReplicateWriteOffCode.value = true;
    } else {
      cancelReplicate();
    }
  }

  function replicateWriteOffCode() {
    for (let item of contract.osRequests) {
      if (item.osNumber !== requestData.osNumber && item.replicate === true) {
        item.writeOffCode = requestData.writeOffCode;
      }
    }
    confirmationReplicateWriteOffCode.value = true;
    modalReplicateWriteOffCode.value = false;
  }

  function setMotivation(value) {
    requestData.motivoValue = value;
  }

  function setSchedulingValue(value) {
    requestData.schedulingValue = value;
  }

  function cancelReplicate() {
    confirmationReplicateWriteOffCode.value = false;
    for (let item of contract.osRequests) {
      item.replicate = false;
    }
  }

  function returnSchemaRequest() {
    let schemaRequest = {
      object_id: requestData.object_id,
      typeOS: requestData.typeOS,
      datePrimary: requestData.datePrimary,
      hourInitialPrimary: requestData.horaPrimary,
      dateSecundary: requestData.dateSecundary,
      hourInitialSecundary: requestData.horaSecundary,
      motivoValue: requestData.motivoValue ?? "",
      schedulingValue: requestData.schedulingValue,
      statusOS: requestData.statusOS,
      writeOffCode: requestData.writeOffCode,
      observation: requestData.observation,
      check: true,
      replicate: requestData.replicate,
      source: requestData.source,
      itemOsContract: requestData.itemOsContract,
      dateStartedAttendance: requestData.dateStartedAttendance,
    };

    return schemaRequest;
  }

  function handleValidateOsRequest() {
    let validate = false;
    requestData.typeOS.text == "REFAZER MANUTENÇÃO"
      ? (validate = _validateRedoMaintenanceSchemaRequest(requestData))
      : (validate = _validateInstallationClearanceSchemaRequest(requestData));

    return validate;
  }

  function _createOsRequestData() {
    // if (props.itemOsContract.data.typeOS.value == 103) {
    //   props.itemOsContract.data.typeOS = [];
    // }
    requestData.object_id = props.itemOsContract.data.object_id;
    requestData.typeOS = [];
    requestData.datePrimary = props.itemOsContract.data.datePrimary;
    requestData.dateSecundary = props.itemOsContract.data.dateSecundary;
    requestData.horaPrimary = props.itemOsContract.data.hourInitialPrimary;
    requestData.horaSecundary = props.itemOsContract.data.hourInitialSecundary;
    requestData.motivoValue = props.itemOsContract.data.motivoValue;
    requestData.schedulingValue = props.itemOsContract.data.schedulingValue;
    requestData.observation = props.itemOsContract.data.observation;
    requestData.statusOS = 1;
    requestData.writeOffCode = props.itemOsContract.data.writeOffCode;
    requestData.check = false;
    requestData.replicate = false;
    requestData.source = "NetSMS";
  }

  function _validateRedoMaintenanceSchemaRequest(requestData) {
    //SOLUÇÃO TEMPORARIA
    if (
      requestData.schedulingValue == "Realizar agendamento" ||
      requestData.schedulingValue == undefined
    ) {
      if (
        requestData.datePrimary == undefined ||
        requestData.horaPrimary == undefined ||
        requestData.dateSecundary == undefined ||
        requestData.horaSecundary == undefined
      ) {
        $q.notify({
          message: "Apenas o campo observação nao é obrigatorio.",
          color: "red-9",
          position: "top",
          timeout: 3000,
        });
        return false;
      }
    }
    if (
      requestData.motivoValue == undefined ||
      requestData.datePrimary == "" ||
      requestData.dateSecundary == "" ||
      requestData.typeOS == "" ||
      requestData.observation == ""
    ) {
      $q.notify({
        message: "Todos os campos são obrigatorios.",
        color: "red-9",
        position: "top",
        timeout: 3000,
      });
      return false;
    }
    return true;
  }

  function _validateInstallationClearanceSchemaRequest(requestData) {
    //SOLUÇÃO TEMPORARIA
    if (
      requestData.schedulingValue == "Realizar agendamento" ||
      requestData.schedulingValue == undefined
    ) {
      if (
        requestData.datePrimary == undefined ||
        requestData.horaPrimary == undefined ||
        requestData.motivoValue == undefined ||
        requestData.dateSecundary == undefined ||
        requestData.horaSecundary == undefined
      ) {
        $q.notify({
          message: "Todos os campos são obrigatórios.",
          color: "red-9",
          position: "top",
          timeout: 3000,
        });
        return false;
      }
    }

    if (
      requestData.schedulingValue == "" ||
      requestData.schedulingValue == undefined ||
      requestData.datePrimary == "" ||
      requestData.motivoValue == undefined ||
      requestData.dateSecundary == "" ||
      requestData.typeOS == "" ||
      requestData.observation == ""
    ) {
      $q.notify({
        message: "Todos os campos são obrigatórios.",
        color: "red-9",
        position: "top",
        timeout: 3000,
      });
      return false;
    }
    return true;
  }

  function _verifyCitiesRoles() {
    let blackListTypeOsDesobstruction = [
      3, 4, 5, 7, 9, 10, 12, 13, 15, 27, 38, 40, 42, 52, 54, 55, 61, 63, 67, 84,
      88, 95, 97, 129, 133, 136, 141, 143, 152, 187, 203, 209, 211, 216, 223,
      228, 230, 269, 272, 276, 277, 291, 295, 336, 353, 360, 420, 423, 443, 456,
      474, 480, 481, 498, 532, 533, 535, 550, 567, 573, 577, 581, 599, 609, 621,
      626, 637, 657, 659, 661, 678, 712, 714, 718, 722, 733, 739, 746, 750, 765,
      787, 802, 807, 808, 810, 823, 833, 843, 847, 852, 856, 869, 886, 907, 924,
      972,
    ];

    let resultBlackList = blackListTypeOsDesobstruction.find(
      (element) => element == props.citySelected.value
    );
  }

  function verifyDrop(value) {
    if (value) {
      emits("clearSchemaRequest", requestData);
    }
  }

  function addDateSchedule() {
    datesAvailableForSelection.date = generateTenDaysWithoutSundayAndHolidays();
  }

  function handleTypeOs(typeOs){
    if(motivoDisabledBytypeOs) {
      setMotivation('Claro')
    }

    if(isMaintenanceTypeOs.value) {
      setSchedulingValue('Abertura imediata');
    } else {
      requestData.reason = '';
      requestData.observation = '';
    }
  }

  function handleObservationByReason(){
    if(requestData.typeOS === '6' && requestData.reason !== ''){
    requestData.observation = `[${requestData.reason}] - `;
        }
  }

watch(() => requestData.observation, (newValue, oldValue) => {
    if(requestData.typeOS !== '6' && requestData.reason === ''){
      return;
    }
    const prefix = `[${requestData.reason}] - `;
    
    if (!newValue || newValue === prefix) {
        requestData.observation = prefix;
        return;
    }
    
    if (!newValue.startsWith(prefix)) {
        const newContent = newValue.replace(/^\[.*?\] - /, '');

        if(/^\[.*?\] ?-? ?/.test(newContent)) {
            requestData.observation = newContent;
            return;
        }else{
          if(newContent.split('[').length > 0) {
            requestData.observation = prefix + '';
            return;
          } else {
          requestData.observation = prefix  + newContent;
          }
        }
    }
});


  const displayScheduleOptions = computed(() => {
    if (isMaintenanceTypeOs.value) {
      return schedulingOptions.slice(1)
    }else if(schedulingOnlyOptionByTypeOs.value){
      return schedulingOptions.slice(0, 1);
    } else {
      return schedulingOptions;
    }
  });

  onBeforeMount(() => {
    addDateSchedule();
    _createOsRequestData();
  });
</script>

<style scoped>
label {
  font-weight: bold;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);
}
</style>
